/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../../../../client-dashboard/src/app/services/api.config';
import useDataFetchIndicator from '../useDataFetchIndicator';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.PartnerAccountTransferResponse,
  partnerAccountTransfer: (params: vp.PartnerAccountTransferRequest) => Promise<vp.PartnerAccountTransferResponse>,
  initiatePartnerAccountTransfer: (params: vp.PartnerAccountTransferRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostPartnerAccountTransfer: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldPartnerAccountTransfer, setShouldPartnerAccountTransfer] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.PartnerAccountTransferRequest>({
    TransferTypeID: '',
    DebitorAccountID: '',
    RecipientAccountID: '',
    Amount: '',
    Currency: '',
    ClientReferenceNumber: '',
    Notes: '',
  });
  const [response, setResponse] = useState<vp.PartnerAccountTransferResponse>({
    Success: false,
    ErrorMessage: '',
    TransactionID: '',
  });

  useEffect(() => {
    if (!shouldPartnerAccountTransfer) return () => {};

    const PostPartnerAccountTransfer = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postPartnerAccountTransfer(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldPartnerAccountTransfer) void PostPartnerAccountTransfer();
    setShouldPartnerAccountTransfer(false);
    return () => {
      source.cancel();
    };
  }, [shouldPartnerAccountTransfer]);

  return [
    response,
    (_params: vp.PartnerAccountTransferRequest) => api.postPartnerAccountTransfer(_params, source),
    (_params: vp.PartnerAccountTransferRequest) => {
      setParams(_params);
      setShouldPartnerAccountTransfer(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        TransactionID: '',
      });
      setShouldPartnerAccountTransfer(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostPartnerAccountTransfer);
